import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Grid2 as Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Paper,
  ImageList,
  ImageListItem,
  Avatar,
  IconButton,
} from "@mui/material";
import {
  Build,
  Edit,
  PhotoCamera,
  Visibility,
  ArrowBack,
} from "@mui/icons-material";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@mui/lab";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { InspectionStatusChip } from "../components/StatusChips";
import PpMobilePhotoCaptureComponent from "../Photos/PpMobilePhotoCaptureComponent";
import PpPhotoAnnotationTools from "../Photos/PpPhotoAnnotationTools";

const PpInspectionPermitView = () => {
  const { permitId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const [permit, setPermit] = useState(null);
  const [inspections, setInspections] = useState([]);
  const [selectedInspection, setSelectedInspection] = useState(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [photosDialogOpen, setPhotosDialogOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [photoCaptureOpen, setPhotoCaptureOpen] = useState(false);
  const [annotationOpen, setAnnotationOpen] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  // Mock permit and inspection data
  const mockPermit = {
    id: permitId,
    number: "PKG2024001",
    address: "123 Oak Street, Jacksonville, FL 32207",
    contractor: {
      name: "ABC Construction",
      license: "CBC012345",
      contact: "john@abcconstruction.com",
    },
    type: "residential",
    status: "active",
    submittedDate: new Date(
      Date.now() - 30 * 24 * 60 * 60 * 1000
    ).toISOString(),
    approvedDate: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    associatedPermits: [
      { id: "MECH001", type: "Mechanical", status: "active" },
      { id: "ELEC001", type: "Electrical", status: "active" },
      { id: "PLUMB001", type: "Plumbing", status: "active" },
    ],
  };

  const mockInspections = [
    {
      id: "INS001",
      name: "Footing/Foundation",
      status: "passed",
      required: true,
      requestedDate: new Date(
        Date.now() - 10 * 24 * 60 * 60 * 1000
      ).toISOString(),
      scheduledDate: new Date(
        Date.now() - 8 * 24 * 60 * 60 * 1000
      ).toISOString(),
      completedDate: new Date(
        Date.now() - 8 * 24 * 60 * 60 * 1000
      ).toISOString(),
      inspector: "Mike Johnson",
      photos: [
        {
          id: "photo1",
          filename: "foundation1.jpg",
          name: "foundation1.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDA2NmNjIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZvdW5kYXRpb24gMTwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDA2NmNjIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZvdW5kYXRpb24gMTwvdGV4dD4KPC9zdmc+",
        },
        {
          id: "photo2",
          filename: "foundation2.jpg",
          name: "foundation2.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDA2NmNjIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZvdW5kYXRpb24gMjwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjMDA2NmNjIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZvdW5kYXRpb24gMjwvdGV4dD4KPC9zdmc+",
        },
      ],
      comments: "Foundation meets code requirements. Ready for next phase.",
      dependencies: [],
      history: [
        {
          date: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
          action: "requested",
          user: "Contractor",
          notes: "Initial inspection request",
        },
        {
          date: new Date(Date.now() - 9 * 24 * 60 * 60 * 1000).toISOString(),
          action: "approved",
          user: "John Smith, PE",
          notes: "Approved for inspection",
        },
        {
          date: new Date(Date.now() - 8 * 24 * 60 * 60 * 1000).toISOString(),
          action: "passed",
          user: "Mike Johnson",
          notes: "Inspection completed successfully",
        },
      ],
    },
    {
      id: "INS002",
      name: "Framing",
      status: "pending",
      required: true,
      requestedDate: new Date(
        Date.now() - 2 * 24 * 60 * 60 * 1000
      ).toISOString(),
      scheduledDate: new Date(
        Date.now() + 2 * 24 * 60 * 60 * 1000
      ).toISOString(),
      completedDate: null,
      inspector: "Mike Johnson",
      photos: [
        {
          id: "photo3",
          filename: "framing1.jpg",
          name: "framing1.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMTwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMTwvdGV4dD4KPC9zdmc+",
        },
        {
          id: "photo4",
          filename: "framing2.jpg",
          name: "framing2.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMjwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMjwvdGV4dD4KPC9zdmc+",
        },
        {
          id: "photo5",
          filename: "framing3.jpg",
          name: "framing3.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMzwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmY2NjAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkZyYW1pbmcgMzwvdGV4dD4KPC9zdmc+",
        },
      ],
      comments: "Awaiting framing inspection. All rough-in work completed.",
      dependencies: ["INS001"],
      history: [
        {
          date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          action: "requested",
          user: "Contractor",
          notes: "Framing inspection requested",
        },
        {
          date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
          action: "approved",
          user: "John Smith, PE",
          notes: "Scheduled for inspection",
        },
      ],
    },
    {
      id: "INS003",
      name: "Electrical Rough-In",
      status: "failed",
      required: true,
      requestedDate: new Date(
        Date.now() - 3 * 24 * 60 * 60 * 1000
      ).toISOString(),
      scheduledDate: new Date(
        Date.now() - 1 * 24 * 60 * 60 * 1000
      ).toISOString(),
      completedDate: new Date(
        Date.now() - 1 * 24 * 60 * 60 * 1000
      ).toISOString(),
      inspector: "Sarah Wilson",
      photos: [
        {
          id: "photo6",
          filename: "electrical1.jpg",
          name: "electrical1.jpg",
          url: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjY2MwMDAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkVsZWN0cmljYWwgMTwvdGV4dD4KPC9zdmc+",
          dataUrl:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjYwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjY2MwMDAwIi8+CiAgPHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIyNCIgZmlsbD0iI2ZmZmZmZiIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkVsZWN0cmljYWwgMTwvdGV4dD4KPC9zdmc+",
        },
      ],
      comments: "Failed inspection - GFCI outlets not properly installed",
      failureReason:
        "NEC 210.8 - GFCI protection required for bathroom and kitchen outlets",
      dependencies: ["INS002"],
      history: [
        {
          date: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
          action: "requested",
          user: "Contractor",
          notes: "Electrical rough-in inspection requested",
        },
        {
          date: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
          action: "approved",
          user: "John Smith, PE",
          notes: "Approved for inspection",
        },
        {
          date: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
          action: "failed",
          user: "Sarah Wilson",
          notes: "Failed - GFCI outlets not compliant with NEC 210.8",
        },
      ],
    },
  ];

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setPermit(mockPermit);
        setInspections(mockInspections);
        // dispatch(loadPermitInspections(permitId));
      } catch (error) {
        console.error("Failed to load permit inspections:", error);
      } finally {
        setLoading(false);
      }
    };

    if (permitId) {
      loadData();
    }
  }, [permitId, dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) return "Not scheduled";
    return new Date(dateString).toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getTimelineDotColor = (action) => {
    const colorMap = {
      requested: "primary",
      approved: "info",
      reported: "secondary",
      passed: "success",
      failed: "error",
      corrections: "warning",
    };
    return colorMap[action] || "grey";
  };

  const getStatusCounts = () => {
    return inspections.reduce((counts, inspection) => {
      counts[inspection.status] = (counts[inspection.status] || 0) + 1;
      return counts;
    }, {});
  };

  const statusCounts = getStatusCounts();

  if (loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading permit inspections...</Typography>
      </Box>
    );
  }

  if (!permit) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Permit not found or failed to load inspection data.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      {/* Header with back arrow */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <IconButton onClick={() => navigate("/pp/inspections")}>
          <ArrowBack />
        </IconButton>
        <Box sx={{ flexGrow: 1 }}>
          <Typography color="primary" variant="h4">
            Permit Inspections - {permit.number}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {permit.address}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {permit.contractor.name} ({permit.contractor.license})
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        {/* Permit Overview */}
        <Grid size={{ xs: 12, md: 4 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Permit Overview
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Permit Type"
                    secondary={
                      permit.type.charAt(0).toUpperCase() + permit.type.slice(1)
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Status"
                    secondary={
                      <Chip
                        label={permit.status}
                        color="success"
                        size="small"
                        sx={{ textTransform: "capitalize" }}
                      />
                    }
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Submitted"
                    secondary={formatDate(permit.submittedDate)}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Approved"
                    secondary={formatDate(permit.approvedDate)}
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>

          {/* Associated Permits */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Associated Permits
              </Typography>
              <List dense>
                {permit.associatedPermits.map((assocPermit) => (
                  <ListItem key={assocPermit.id}>
                    <ListItemIcon>
                      <Build fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                      primary={assocPermit.type}
                      secondary={assocPermit.id}
                    />
                    <Chip
                      label={assocPermit.status}
                      color="primary"
                      size="small"
                      variant="outlined"
                    />
                  </ListItem>
                ))}
              </List>
            </CardContent>
          </Card>

          {/* Inspection Summary */}
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Inspection Summary
              </Typography>
              <Grid container spacing={1}>
                <Grid size={{ xs: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Total:
                  </Typography>
                  <Typography variant="h6">{inspections.length}</Typography>
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Passed:
                  </Typography>
                  <Typography variant="h6" color="success.main">
                    {statusCounts.passed || 0}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Pending:
                  </Typography>
                  <Typography variant="h6" color="warning.main">
                    {statusCounts.pending || 0}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Failed:
                  </Typography>
                  <Typography variant="h6" color="error.main">
                    {statusCounts.failed || 0}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* Inspections List */}
        <Grid size={{ xs: 12, md: 8 }}>
          <Card>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography variant="h6">Inspection Timeline</Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    onClick={() => navigate("/pp/inspections")}
                  >
                    Back to Board
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<Edit />}
                    onClick={() => navigate(`/pp/inspections/${permitId}/edit`)}
                  >
                    Edit Inspections
                  </Button>
                </Box>
              </Box>

              {inspections.length === 0 ? (
                <Alert severity="info">
                  No inspections have been defined for this permit yet.
                </Alert>
              ) : (
                <List>
                  {inspections.map((inspection, index) => (
                    <React.Fragment key={inspection.id}>
                      <ListItem
                        sx={{
                          border: 1,
                          borderColor: "grey.200",
                          borderRadius: 2,
                          mb: 2,
                          bgcolor:
                            inspection.status === "failed"
                              ? "error.light"
                              : inspection.status === "passed"
                                ? "#e8f5e8"
                                : "background.paper",
                          "&:hover": { bgcolor: "action.hover" },
                        }}
                      >
                        <ListItemIcon>
                          <Avatar
                            sx={{
                              bgcolor:
                                inspection.status === "passed"
                                  ? "success.main"
                                  : inspection.status === "failed"
                                    ? "error.main"
                                    : inspection.status === "pending"
                                      ? "warning.main"
                                      : "primary.main",
                            }}
                          >
                            {index + 1}
                          </Avatar>
                        </ListItemIcon>

                        <ListItemText
                          primary={
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mb: 1,
                              }}
                            >
                              <Typography variant="subtitle1" fontWeight="bold">
                                {inspection.name}
                              </Typography>
                              <InspectionStatusChip
                                status={inspection.status}
                              />
                              {inspection.required && (
                                <Chip
                                  label="Required"
                                  color="error"
                                  size="small"
                                  variant="outlined"
                                />
                              )}
                            </Box>
                          }
                          secondary={
                            <Box>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                Inspector: {inspection.inspector}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                Requested:{" "}
                                {formatDate(inspection.requestedDate)}
                              </Typography>
                              {inspection.scheduledDate && (
                                <Typography variant="body2" color="primary">
                                  Scheduled:{" "}
                                  {formatDate(inspection.scheduledDate)}
                                </Typography>
                              )}
                              {inspection.completedDate && (
                                <Typography
                                  variant="body2"
                                  color="success.main"
                                >
                                  Completed:{" "}
                                  {formatDate(inspection.completedDate)}
                                </Typography>
                              )}

                              {inspection.photos?.length > 0 && (
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    mt: 1,
                                  }}
                                >
                                  <PhotoCamera
                                    fontSize="small"
                                    color="primary"
                                  />
                                  <Typography variant="caption">
                                    {inspection.photos.length} photos
                                  </Typography>
                                </Box>
                              )}

                              {inspection.dependencies?.length > 0 && (
                                <Box sx={{ mt: 1 }}>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Dependencies:{" "}
                                    {inspection.dependencies.join(", ")}
                                  </Typography>
                                </Box>
                              )}

                              {inspection.comments && (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    mt: 1,
                                    p: 1,
                                    bgcolor: "background.paper",
                                    borderRadius: 1,
                                    border: 1,
                                    borderColor: "grey.200",
                                  }}
                                >
                                  {inspection.comments}
                                </Typography>
                              )}

                              {inspection.failureReason && (
                                <Alert severity="error" sx={{ mt: 1 }}>
                                  <strong>Failure Reason:</strong>{" "}
                                  {inspection.failureReason}
                                </Alert>
                              )}
                            </Box>
                          }
                        />

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                          }}
                        >
                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Visibility />}
                            onClick={() => {
                              setSelectedInspection(inspection);
                              setDetailDialogOpen(true);
                            }}
                          >
                            Details
                          </Button>

                          {inspection.photos?.length > 0 && (
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<PhotoCamera />}
                              color="primary"
                              onClick={() => {
                                setSelectedInspection(inspection);
                                setPhotosDialogOpen(true);
                              }}
                            >
                              Photos ({inspection.photos.length})
                            </Button>
                          )}

                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<PhotoCamera />}
                            color="success"
                            onClick={() => {
                              setSelectedInspection(inspection);
                              setPhotoCaptureOpen(true);
                            }}
                          >
                            Capture Photos
                          </Button>

                          {inspection.photos?.length > 0 && (
                            <Button
                              size="small"
                              variant="outlined"
                              startIcon={<Edit />}
                              color="secondary"
                              onClick={() => {
                                setSelectedPhoto(inspection.photos[0]);
                                setAnnotationOpen(true);
                              }}
                            >
                              Annotate
                            </Button>
                          )}
                        </Box>
                      </ListItem>
                    </React.Fragment>
                  ))}
                </List>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Inspection Detail Dialog */}
      <Dialog
        open={detailDialogOpen}
        onClose={() => setDetailDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Build />
            {selectedInspection?.name} - Inspection Details
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedInspection && (
            <Box>
              {/* Basic Info */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Status
                  </Typography>
                  <InspectionStatusChip status={selectedInspection.status} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Inspector
                  </Typography>
                  <Typography variant="body1">
                    {selectedInspection.inspector}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Requested
                  </Typography>
                  <Typography variant="body1">
                    {formatDate(selectedInspection.requestedDate)}
                  </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                  <Typography variant="subtitle2" color="text.secondary">
                    Scheduled
                  </Typography>
                  <Typography variant="body1">
                    {formatDate(selectedInspection.scheduledDate)}
                  </Typography>
                </Grid>
              </Grid>

              {/* Photos */}
              {selectedInspection.photos?.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Photos ({selectedInspection.photos.length})
                  </Typography>
                  <ImageList cols={3} rowHeight={120}>
                    {selectedInspection.photos.map((photo, index) => (
                      <ImageListItem key={index}>
                        <Paper
                          sx={{
                            height: 120,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: "grey.100",
                          }}
                        >
                          <img
                            src={photo.url || photo.dataUrl}
                            alt={
                              photo.filename ||
                              photo.name ||
                              `Photo ${index + 1}`
                            }
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: 4,
                            }}
                          />
                        </Paper>
                      </ImageListItem>
                    ))}
                  </ImageList>
                </Box>
              )}

              {/* History Timeline */}
              <Typography variant="h6" gutterBottom>
                Inspection History
              </Typography>
              <Timeline>
                {selectedInspection.history?.map((event, index) => (
                  <TimelineItem key={index}>
                    <TimelineSeparator>
                      <TimelineDot color={getTimelineDotColor(event.action)} />
                      {index < selectedInspection.history.length - 1 && (
                        <TimelineConnector />
                      )}
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        variant="subtitle2"
                        sx={{ textTransform: "capitalize" }}
                      >
                        {event.action.replace("_", " ")}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {event.user} • {formatDate(event.date)}
                      </Typography>
                      {event.notes && (
                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                          {event.notes}
                        </Typography>
                      )}
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetailDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Photos Dialog */}
      <Dialog
        open={photosDialogOpen}
        onClose={() => setPhotosDialogOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PhotoCamera />
            {selectedInspection?.name} - Photos
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedInspection?.photos &&
          selectedInspection.photos.length > 0 ? (
            <ImageList cols={3} rowHeight={200} sx={{ width: "100%" }}>
              {selectedInspection.photos.map((photo, index) => (
                <ImageListItem key={index}>
                  <Paper
                    sx={{
                      height: 200,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "grey.100",
                      p: 2,
                      cursor: "pointer",
                      "&:hover": {
                        bgcolor: "grey.200",
                      },
                    }}
                    onClick={() => {
                      // In a real app, this would open the full-size image
                    }}
                  >
                    <img
                      src={photo.url || photo.dataUrl}
                      alt={photo.filename || photo.name || `Photo ${index + 1}`}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: 4,
                        marginBottom: 8,
                      }}
                    />
                    <Typography variant="body2" textAlign="center">
                      {photo.filename || photo.name || `Photo ${index + 1}`}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Click to view full size
                    </Typography>
                  </Paper>
                </ImageListItem>
              ))}
            </ImageList>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 4,
              }}
            >
              <PhotoCamera sx={{ fontSize: 80, color: "grey.400", mb: 2 }} />
              <Typography variant="h6" color="text.secondary">
                No photos available
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPhotosDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Photo Capture Dialog */}
      <PpMobilePhotoCaptureComponent
        open={photoCaptureOpen}
        onClose={() => setPhotoCaptureOpen(false)}
        onPhotosUploaded={(photos) => {
          // Update inspection with new photos
          if (selectedInspection) {
            setInspections((prev) =>
              prev.map((ins) =>
                ins.id === selectedInspection.id
                  ? {
                      ...ins,
                      photos: [
                        ...(ins.photos || []),
                        ...photos.map((photo, index) => ({
                          id: `new_photo_${Date.now()}_${index}`,
                          filename: photo.filename || `Photo_${Date.now()}.jpg`,
                          name: photo.filename || `Photo_${Date.now()}.jpg`,
                          url: photo.dataUrl,
                          dataUrl: photo.dataUrl,
                        })),
                      ],
                    }
                  : ins
              )
            );
          }
          setPhotoCaptureOpen(false);
        }}
        category="inspection"
        inspectionId={selectedInspection?.id}
        propertyId={permit?.id}
      />

      {/* Photo Annotation Dialog */}
      {selectedPhoto && (
        <Dialog
          open={annotationOpen}
          onClose={() => setAnnotationOpen(false)}
          maxWidth="xl"
          fullWidth
          fullScreen
        >
          <DialogTitle>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Edit />
              Photo Annotation - {selectedInspection?.name}
            </Box>
          </DialogTitle>
          <DialogContent sx={{ p: 0 }}>
            <PpPhotoAnnotationTools
              photo={selectedPhoto}
              photoList={selectedInspection?.photos || []}
              onSave={(annotatedPhoto) => {
                setAnnotationOpen(false);
              }}
              onCancel={() => setAnnotationOpen(false)}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default PpInspectionPermitView;
